import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { MCButton, Avatar, View, MCText } from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { remCss, withRouter, userFullName, scssVariables as variables, lang } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

function formatEarnings(val, currency) {
  if (!val) return `0 ${currency}`;
  if (val.toString().split('.')[1]?.length > 2) {
    return val.toFixed(2) + ' ' + currency;
  } else {
    return val + ' ' + currency;
  }
}

class StatsOfDoctors extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  prevWeek = () => {
    console.log('prevWeek');
    let startDate = model.input('startDate').clone();
    let newStartDate = startDate.clone().startOf('isoWeek').subtract(1, 'week');
    let newEndDate = newStartDate.clone().add('1', 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  nextWeek = () => {
    console.log('nextWeek');
    let endDate = model.input('endDate').clone();
    let newStartDate = endDate.startOf('isoWeek');
    let newEndDate = newStartDate.clone().add(1, 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  renderDetailSection = (prefix, item, hasLabel) => {
    let size = 18;
    return (
      <View style={{ gap: remCss(5) }}>
        <View style={{ flexDirection: 'row' }}>
          {hasLabel && (
            <MCText
              label={lang.t(LANG_CONST.appointments).toLowerCase() + ': '}
              weight={500}
              size={size}
            />
          )}
          <MCText
            label={`${item[prefix + '_appointment']} / ${formatEarnings(item[prefix + '_appointmentEarnings'], model.getCurrency())}`}
            weight={500}
            size={size}
          />
        </View>
        <View style={{ flexDirection: 'row' }}>
          {hasLabel && (
            <MCText label={lang.t(LANG_CONST.tickets).toLowerCase() + ': '} size={size} />
          )}
          <MCText
            label={`${item[prefix + '_ticket']} / ${formatEarnings(item[prefix + '_ticketEarnings'], model.getCurrency())}`}
            weight={400}
            size={size}
          />
        </View>
        <View style={{ flexDirection: 'row' }}>
          {hasLabel && (
            <MCText label={lang.t(LANG_CONST.treatments).toLowerCase() + ': '} size={size} />
          )}
          <MCText label={item[prefix + '_treatment']} weight={400} size={size} />
        </View>
      </View>
    );
  };
  getTotalData = () => {
    const statFields = [
      'appointment',
      'appointmentEarnings',
      'treatment',
      'ticket',
      'ticketEarnings',
      'earnings'
    ];
    let total = {};
    statFields.forEach((field) => {
      total[`between_${field}`] = model.getTotalData('between', field);
      total[`today_${field}`] = model.getTotalData('today', field);
      total[`yesterday_${field}`] = model.getTotalData('yesterday', field);
      total[`week_${field}`] = model.getTotalData('week', field);
    });

    return total;
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    const totalData = this.getTotalData();

    const medium = !this.props.screenDetail?.isLargeScreen;

    const columns = [
      {
        label: LANG_CONST.doctors,
        cellStyles: { alignItems: 'flex-start' },
        resize: true,
        width: medium ? `${remCss(180)}px` : `${remCss(280)}px`,
        renderCell: (item) => (
          <div
            className={medium ? 'mc-flex-col-10' : 'mc-flex-10'}
            style={{ alignItems: 'flex-start' }}
          >
            <div style={{ marginRight: 4 }}>
              <Avatar text={userFullName(item)} width={50} height={50} image={item.avatar} />
            </div>
            <div className={'mc-flex-5-col'}>
              <div className={'mc-value-518 mc-value-truncate'}>
                {item.firstName} {item.lastName}
              </div>
              <div className={'mc-value-518 mc-value-truncate'}>{item.email}</div>
              <div className={'mc-value-418 mc-value-truncate'}>
                <span style={{ position: 'relative', top: 4 }}>
                  <SVGIcon width={20} iconname={'phone-icon'} />
                </span>
                {formatPhoneNumberIntl((item.phoneNumber || '').toString())}
              </div>
            </div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <View style={{ textAlign: 'right', gap: remCss(5) }}>
                <div>appointments:</div>
                <div>tickets:</div>
                <div>treatments:</div>
              </View>
            )
      },
      {
        label: 'Today',
        resize: true,
        cellStyles: { alignItems: 'flex-start' },
        renderCell: (item) => (
          <>
            {this.renderDetailSection('today', item, true)}
            {medium && this.state.openId === item.id && (
              <View style={{ marginTop: remCss(10), gap: remCss(5) }}>
                <MCText label={'Yesterday'} weight={500} />
                {this.renderDetailSection('yesterday', item, true)}
              </View>
            )}
          </>
        ),
        footer: loading
          ? null
          : () => (
              <>
                {this.renderDetailSection('today', totalData)}
                {medium && this.state.openId === 'total' && (
                  <View style={{ marginTop: remCss(10), gap: remCss(5) }}>
                    <MCText label={'Yesterday'} weight={500} />
                    {this.renderDetailSection('yesterday', totalData)}
                  </View>
                )}
              </>
            )
      },
      !medium && {
        label: 'Yesterday',
        resize: true,
        cellStyles: { alignItems: 'flex-start' },
        // minWidth: '80',
        renderCell: (item) => this.renderDetailSection('yesterday', item),
        footer: loading ? null : () => this.renderDetailSection('yesterday', totalData)
      },
      !medium && {
        label: 'Last Week',
        resize: true,
        cellStyles: { alignItems: 'flex-start' },
        // minWidth: '80',
        renderCell: (item) => this.renderDetailSection('week', item),
        footer: loading ? null : () => this.renderDetailSection('week', totalData)
      },
      {
        label:
          model.input('startDate').format('D MMM') + ' - ' + model.input('endDate').format('D MMM'),
        // width: '10%',
        width: `${remCss(160)}px`,
        cellStyles: { alignItems: 'flex-start' },
        renderCell: (item) => (
          <>
            {this.renderDetailSection('between', item, false)}
            {medium && this.state.openId === item.id && (
              <View style={{ marginTop: remCss(10), gap: remCss(5) }}>
                <MCText label={'Last Week'} weight={500} />
                {this.renderDetailSection('week', item, false)}
              </View>
            )}
          </>
        ),
        footer: loading
          ? null
          : () => (
              <>
                {this.renderDetailSection('between', totalData)}
                {medium && this.state.openId === 'total' && (
                  <View style={{ marginTop: remCss(10), gap: remCss(5) }}>
                    <MCText label={'Last Week'} weight={500} />
                    {this.renderDetailSection('week', totalData)}
                  </View>
                )}
              </>
            )
      },
      {
        label: '',
        width: `${remCss(100)}px`,
        cellStyles: { textAlign: 'end', alignItems: 'flex-start' },
        renderCell: (item) => {
          const paid = item.between_paid;
          let label = (
            <MCButton
              outline
              small
              label={LANG_CONST.soon}
              radius
              style={{ width: 75 }}
              quaternary
            />
          );
          if (item.between_earnings === 0)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.zero}
                radius
                style={{ width: remCss(75) }}
              />
            );
          else if (paid === true)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.paid}
                radius
                style={{ width: remCss(75) }}
              />
            );

          return (
            <View style={{ gap: remCss(15) }}>
              <View style={{ alignItems: 'flex-end' }}>{label}</View>
              {medium && (
                <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                  <MCButton
                    onClick={() =>
                      this.setState({ openId: this.state.openId === item.id ? null : item.id })
                    }
                    tiny
                    quaternary
                    light
                    radius
                    hover={true}
                  >
                    <span
                      className={
                        'mc-rotate ' + (this.state.openId === item.id ? 'mc-rotate-180' : '')
                      }
                      style={{ height: remCss(44) }}
                    >
                      <SVGIcon
                        iconname={BASE_ICONS.DOWN}
                        width={44}
                        padding={5}
                        fill={variables['colors-mc-orange']}
                      />
                    </span>
                  </MCButton>
                </View>
              )}
            </View>
          );
        },
        footer:
          loading || !medium
            ? null
            : () => {
                return (
                  <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <MCButton
                      onClick={() =>
                        this.setState({ openId: this.state.openId === 'total' ? null : 'total' })
                      }
                      tiny
                      quaternary
                      light
                      radius
                      hover={true}
                    >
                      <span
                        className={
                          'mc-rotate ' + (this.state.openId === 'total' ? 'mc-rotate-180' : '')
                        }
                        style={{ height: remCss(44) }}
                      >
                        <SVGIcon
                          iconname={BASE_ICONS.DOWN}
                          width={44}
                          padding={5}
                          fill={variables['colors-mc-orange']}
                        />
                      </span>
                    </MCButton>
                  </View>
                );
              }
      }
    ].filter((c) => !!c);

    return (
      <div className={'mc-container-content__body'}>
        <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
          <TableLibrary
            key={columns.length}
            loading={loading}
            noResults={noResults}
            searchQuery={searchQuery}
            sortBy={model.state.sortBy}
            showPagination={false}
            onSortChange={(sortBy) => {
              model.handleChange('sortBy', sortBy);
              model.setListState({ items: [] }, model.getCurrentId(), null, true);
              model.loadMore();
            }}
            columns={columns}
            data={items}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(StatsOfDoctors);
